import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { getBrowserLocale } from './app/shared/utils/locale.utils';

// ✅ AG Grid setup
import { ModuleRegistry } from 'ag-grid-community';
import { AllCommunityModule } from 'ag-grid-community';

// ✅ Register all community modules before bootstrap
ModuleRegistry.registerModules([AllCommunityModule]);

registerLocaleData(localeFr);
registerLocaleData(localeEn);

if (typeof document !== 'undefined') {
  document.documentElement.lang = getBrowserLocale();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
